import React from "react";
import HideRight from "../../misc/HideRight";
import ChartComponentLayoutChooser from "./ChartComponentLayoutChooser";

export default class ChartSectionHead extends React.Component {
	render() {
		return (
			<div className="section-footer">
				<HideRight {...this.props} />
				<ChartComponentLayoutChooser />
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/ChartSectionHead.jsx
 **/